import './components/regiondo';
import './components/anchortags';

require('bootstrap');
